module.exports = __webpack_public_path__ + "static/media/mhubbg.5bc486b1.jpg";